<template>
    <div>
        Great news! We have found a better deal than your current supply at {{notification.relations.recommendation.property.currentPropertyAddress}}.
        We have passed your details to your new supplier and they will be in touch soon in order to complete the switch.
        <h4 class="text-center mt-3">Your New best Deal!</h4>
        <hr>
        <deal-summary :deal="notification.relations.recommendation"/>
    </div>
</template>

<script>
import DealSummary from "@/components/setup/DealSummary";

export default {
    name: "RecommendationReceived",
    components: {DealSummary},
    props: {
        notification: Object
    },
}
</script>

<style scoped>

</style>
